var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraudationCap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 9,
    viewBox: "0 0 11 9",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3118 2.5212C10.5201 2.61078 10.6118 2.80953 10.5959 2.99994H10.6001V6.3332C10.6001 6.56319 10.4134 6.74985 10.1834 6.74985C9.95345 6.74985 9.76678 6.56319 9.76678 6.3332V3.59368L5.60021 5.08323L0.916575 3.40868C0.508252 3.26285 0.490752 2.69203 0.889076 2.5212L5.60021 0.5L10.3118 2.5212ZM5.31969 5.8683L5.6001 5.96871L5.88093 5.8683L8.93336 4.77707V7.58367C8.04338 8.35949 6.87924 8.83364 5.6001 8.83364C4.32096 8.83364 3.15682 8.35949 2.26685 7.58367V4.77665L5.31969 5.8683Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraudationCap);
export default __webpack_public_path__ + "static/media/graudation-cap.17ad31a7eea949b0ccb20a785cf60933.svg";
export { ForwardRef as ReactComponent };